import { DEFAULT_TIMEZONE } from '../../constants/region';
import { IApplicationState } from '../../types/redux';

export const getTimezone = (state: IApplicationState): number => {
  return state.newbuilding.geo.timezone ?? DEFAULT_TIMEZONE;
};
